import { observer } from "mobx-react-lite";
import { Navigate, Outlet } from "react-router-dom";
import { usePageContext } from "../context/PageContext";
import Button from "../ui/Button/Button";

const PrivateLayout = observer(() => {
	const { pageStore } = usePageContext();

	if (!pageStore.isAuth) {
		return <Navigate to="/login" replace />;
	}

	return (
		<>
			<div className="logout">
                <Button className={'ghost'} onClick={() => pageStore.logout()}>
                    Log out
                </Button>
            </div>
			<Outlet />
		</>
	);
});

export default PrivateLayout;
